/* tslint:disable */
/* eslint-disable */
/**
 * Contract Management API
 * API for managing contracts
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GroupContractBankAccountDto
 */
export interface GroupContractBankAccountDto {
    /**
     * 
     * @type {string}
     * @memberof GroupContractBankAccountDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GroupContractBankAccountDto
     */
    iban: string;
    /**
     * 
     * @type {string}
     * @memberof GroupContractBankAccountDto
     */
    label: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GroupContractBankAccountDto
     */
    isDefault: boolean;
    /**
     * True if a RIB document (StoredFile) is attached to the bank account.
     * @type {boolean}
     * @memberof GroupContractBankAccountDto
     */
    hasRib: boolean;
}

/**
 * Check if a given object implements the GroupContractBankAccountDto interface.
 */
export function instanceOfGroupContractBankAccountDto(value: object): value is GroupContractBankAccountDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('iban' in value) || value['iban'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('isDefault' in value) || value['isDefault'] === undefined) return false;
    if (!('hasRib' in value) || value['hasRib'] === undefined) return false;
    return true;
}

export function GroupContractBankAccountDtoFromJSON(json: any): GroupContractBankAccountDto {
    return GroupContractBankAccountDtoFromJSONTyped(json, false);
}

export function GroupContractBankAccountDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GroupContractBankAccountDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'iban': json['iban'],
        'label': json['label'],
        'isDefault': json['isDefault'],
        'hasRib': json['hasRib'],
    };
}

export function GroupContractBankAccountDtoToJSON(json: any): GroupContractBankAccountDto {
    return GroupContractBankAccountDtoToJSONTyped(json, false);
}

export function GroupContractBankAccountDtoToJSONTyped(value?: GroupContractBankAccountDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'iban': value['iban'],
        'label': value['label'],
        'isDefault': value['isDefault'],
        'hasRib': value['hasRib'],
    };
}

